/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ResetPasswordRequest {
  /**
     * @minLength 1
     * @maxLength 1000
     */
  token: string;
  /**
     * @minLength 8
     * @maxLength 128
     */
  password: string;
}
